import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

interface Props {
  action: string;
  confirmAction: () => void;
  open: boolean;
  setOpen: (open: boolean) => void;
}

function VideoModerationConfirmModal(props: Props) {
  const { action, confirmAction, open, setOpen } = props;

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogTitle id='alert-dialog-title'>
        Confirm Video Moderation
      </DialogTitle>
      <DialogContent>
        <DialogContentText id='alert-dialog-description'>
          Are you sure you want to {action} this video?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={confirmAction} color='primary'>
          Confirm
        </Button>
        <Button onClick={handleClose} autoFocus>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default VideoModerationConfirmModal;
